import React from 'react';
import PropTypes from 'prop-types';

const sizes = {
  small: ['16px', '16px'],
  smallX: ['18px', '18px'],
  middle: ['24px', '24px'],
  large: ['32px', '32px'],
  huge: ['64px', '64px'],
};

const UpIcon = ({ size, style, shouldPadding, ...other }) => {
  const sizePoints = typeof size === 'string' ? sizes[size] : size;
  const [width, height] = sizePoints;

  const svgProps = {
    width,
    height,
    style: Object.assign(shouldPadding ? { padding: '4px' } : {}, style),
    ...other,
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      strokeWidth="2"
      {...svgProps}
    >
      <path
        fill="currentColor"
        d="M12.7071 7.29289L19.7782 14.364C20.1687 14.7545 20.1687 15.3876 19.7782 15.7782C19.3877 16.1687 18.7545 16.1687 18.364 15.7782L12 9.41421L5.63606 15.7782C5.24554 16.1687 4.61237 16.1687 4.22185 15.7782C3.83132 15.3877 3.83132 14.7545 4.22185 14.364L11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289Z"
      />
    </svg>
  );
};
UpIcon.defaultProps = {
  size: 'middle',
  shouldPadding: false,
};
UpIcon.propTypes = {
  style: PropTypes.object,
  size: PropTypes.oneOf(['small', 'smallX', 'middle', 'large', 'huge']),
  shouldPadding: PropTypes.bool,
};

export default UpIcon;
